export enum SpecialErrorCodes {
  TrajectDeletionWithAdvisor = 'error-traject-deletion-with-advisor-invalid'
}
